import * as moment from 'moment';

export const canUpdateRoute = (userInfo) => {
    if (userInfo?.id === 1 || userInfo?.userRoles?.map(item => item.userRoleId).indexOf(1) > -1)
        return true;
    const now = Number(moment().format('HH'))
    return now < 15 && now >= 6
}